module.exports = __webpack_public_path__ + "img/sld_spare_1_t1_dark.f6af2e91.svg";